
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmTabs } from "@afe/amui/src/components/Tabs";
import { AmIcon } from "@afe/amui/src/components/Icon";
import { AmButton } from "@afe/amui/src/components/Button";

import HeaderBox from "./HeaderBox.vue";
import ListBox from "./ListBox.vue";
import get from "lodash/get";

const getKeyByValue = (object: any, value: string) => {
  return Object.keys(object).find(key => object[key] === value);
};

@Component({
  components: { AmTypography, AmTabs, AmIcon, AmButton, HeaderBox, ListBox }
})
export default class extends Vue {
  @Prop(String) readonly json!: string;
  @Prop(String) readonly i18n!: string;
  @Prop(String) readonly regulator!: string;
  @Prop(String) readonly baseUrl!: string;
  @Prop(String) readonly initialPath!: string;

  jsonData = JSON.parse(this.json);
  messages = JSON.parse(this.i18n);
  search = "";
  type = "byExchange";
  path = this.initialPath || this.jsonData.tabs[0].value;
  selected = this.path.split(".").shift();
  instruments = this.jsonData.instruments;
  slugs = this.jsonData.slugs;
  downloadAllLinks = this.jsonData.downloadInstrumentLinks;
  history = window.history;

  get tabs() {
    return this.jsonData.tabs.map((tab: any) => {
      const baseUrl = new URL(this.baseUrl);
      baseUrl.pathname += `/${tab.value.toLowerCase()}`;

      return {
        ...tab,
        href: baseUrl.href
      };
    });
  }

  get currentGroup() {
    const prevPath = this.path
      .split(".")
      .slice(0, -1)
      .join(".");

    return get(this.instruments, `${prevPath}.name`, "");
  }

  get hasSortType() {
    const hasFilter = get(this.instruments, this.path).find(
      ({ is_filter }: any) => !!is_filter
    );

    return !!hasFilter;
  }

  get hasDownloadLink() {
    return this.downloadAllLinks.hasOwnProperty(this.selected);
  }

  get downloadLink() {
    return this.downloadAllLinks[this.selected];
  }

  onChange(path: string) {
    this.path = path;
    this.search = "";
  }

  onChangeTab(tab: string) {
    this.path = tab;
    this.search = "";
    this.type = "byExchange";
  }

  onReturn() {
    this.search = "";
    this.type = "byExchange";
    this.path = this.path
      .split(".")
      .slice(0, -2)
      .join(".");
  }

  getUrlByPath(path: string) {
    const url = getKeyByValue(this.slugs, path);
    const baseUrl = new URL(this.baseUrl);
    baseUrl.pathname += `/${url}`;

    return url ? baseUrl.href : null;
  }

  @Watch("path")
  async changePath(path: string) {
    this.history.pushState({}, "", this.getUrlByPath(path));
    window.dispatchEvent(new CustomEvent("onpushstate"));
  }

  groupPath(groupId: number) {
    const index = get(this.instruments, this.path).findIndex(
      ({ id }: any) => id === groupId
    );

    if (index === -1) {
      return;
    }

    const item = get(this.instruments, `${this.path}.${index}`);

    return item.subtype
      ? `${this.path}.${index}.subtype`
      : `${this.path}.${index}.instruments`;
  }

  groupUrl(groupId: number) {
    const path = this.groupPath(groupId);

    return path ? this.getUrlByPath(path) : null;
  }
}
